<template>
	<div class="page" style="position: relative;overflow-y: auto;">
		<div class="titleView">
			<el-row>
				<el-col :span="5">
					<div style="font-size: 16px;font-weight: bold;padding:0 10px;">资产详情</div>
				</el-col>
				<el-col :span="4" :offset="8">
					<el-button type="warning" size="small" @click="unbundlingAll">全部解绑</el-button>
					<el-button type="warning" size="small" @click="distribution">分配员工</el-button>
				</el-col>
				<el-col :span="2">
					<el-button size="small" @click="$router.back()">返回</el-button>
				</el-col>
			</el-row>
		</div>
		<div class="titleView">
			<el-row style="padding: 10px;">
				<el-col :span="4">
					<div style="padding:0 10px;">分类:{{infoObj&&infoObj.assetsType.name}}</div>
				</el-col>
				<el-col :span="4">
					<div>编号:{{infoObj&&infoObj.assetsCode}}</div>
				</el-col>
				<el-col :span="4">
					<div>名称:{{infoObj&&infoObj.assetsName}}</div>
				</el-col>
				<el-col :span="4">
					<div>规格:{{infoObj&&infoObj.skuName}}</div>
				</el-col>
				<el-col :span="4">
					<div>库存:{{infoObj&&infoObj.stockInfo.already+infoObj.stockInfo.wait+infoObj.stockInfo.lock}}</div>
				</el-col>
			</el-row>
			<el-row style="padding: 10px;">
				<el-col :span="4">
					<div>未分配:{{infoObj&&infoObj.stockInfo.wait}}</div>
				</el-col>
				<el-col :span="4">
					<div>调拨中:{{infoObj&&infoObj.stockInfo.lock}}</div>
				</el-col>
			</el-row>
		</div>
		<el-table :data="tableData" style="width: 100%">
			<el-table-column prop="no" label="员工" column-key="tab3key1">
				<template slot-scope="scope">
					{{scope.row.staffInfo
&&scope.row.staffInfo.name}}
				</template>
			</el-table-column>
			<el-table-column label="负责数量" column-key="tab3key2">
				<template slot-scope="scope">
					{{scope.row.stockInfo.reality}}
				</template>
			</el-table-column>
			<el-table-column label="锁定数量" column-key="tab3key4">
				<template slot-scope="scope">
					<span>{{scope.row.stockInfo.lock}}</span>
				</template>
			</el-table-column>

			<el-table-column label="位置" column-key="tab3key5">
				<template slot-scope="scope">
					{{scope.row.position?scope.row.position:'' }}
				</template>
			</el-table-column>

			<el-table-column label="操作" column-key="tab3key7">
				<template slot-scope="scope">
					<el-button type="text" size="small" @click="listForStaff(scope.row)">查看</el-button>
					<el-button type="text" size="small" @click="unbundling(scope.row)">解绑</el-button>
					<el-button type="text" size="small" v-show="scope.row.stockInfo.lock" @click="handoverT(scope.row)">交接</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 查看员工资产详情 -->
		<div v-if="drawerSeeProduct_state">
			<drawerSeeProduct :info="ForStaffInfo" @submit="drawerSeeProduct_state=false"></drawerSeeProduct>
		</div>
		<!-- 分配 -->
		<el-dialog title="分配员工" :visible.sync="dialogFormVisible">
			<div style="margin-left: 53px;margin-bottom: 10px;">可分配数&nbsp;&nbsp; {{infoObj&&infoObj.stockInfo.wait}}</div>
			<el-form >
				<el-form-item label="分配数量" :label-width="formLabelWidth">
					<el-input v-model="count" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="分配员工" :label-width="formLabelWidth">
					<el-select v-model="userId" placeholder="请选择员工">
						<el-option v-for="item in StaffList" :key="item._id" :label="item.basic_info.nick_name" :value="item._id" />
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="fenPei">确 定</el-button>
			</div>
		</el-dialog>
		<!-- 交接 -->
		<el-dialog title="员工解绑" :visible.sync="handoverShow">
			<div style="margin-left: 53px;margin-bottom: 10px;">可交接数&nbsp;&nbsp; {{lockNumber}}</div>
			<el-form >
				<el-form-item label="交接数量" :label-width="formLabelWidth">
					<el-input v-model="countNumber" autocomplete="off"></el-input>
				</el-form-item>
				{{handoverId}}
				<el-form-item label="交接员工" :label-width="formLabelWidth">

					<el-select v-model="handoverId" placeholder="请选择员工">
						<el-option v-for="item in StaffList" :key="item._id" :label="item.basic_info.real_name" :value="item._id" />
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="handoverShow = false">取 消</el-button>
				<el-button type="primary" @click="handoverShow = false">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import drawerSeeProduct from "./drawer_seeProduct.vue"

	export default {
		components: {
			drawerSeeProduct,
		},
		data() {
			return {
				drawerSeeProduct_state: false,
				formLabelWidth: '120px',
				tableData: [],
				infoObj: null,
				form: {
					name: '',
					number: '',
				},
				dialogFormVisible: false,
				handoverShow: false,
				count:'',
				lockNumber: null,
				ForStaffInfo: null,
				StaffList: [], //员工列表
				userId: '', //员工id
				staffName: '',
				handoverId:'',
				countNumber:''
			}
		},
		mounted() {

			this.getAssetInfo();
			if (this.$route.query.info) {
				this.infoObj = this.$route.query.info
				
			}
			this.getTableData();
		},
		computed: {

		},
		methods: {
			// 分配
			fenPei() {
				let loading = this.$loading();
				let params = {
					"receiveInfo": {
						"id": this.userId,
						"name": this.$public.getMatchingItem(this.StaffList, '_id', this.userId).basic_info.real_name
					},
					"remark":'',
					"shopInfo": this.infoObj.shopInfo,
					  "assetsList": [
					      {
					        "assetsCode": this.infoObj.assetsCode,
					        "assetsName":  this.infoObj.assetsName,
					        "skuName": this.infoObj.skuName,
					        "count":this.count*1,
					        "assetsType":  this.infoObj.assetsType
					      }
					    ]
				}
				this.$http.post(process.env.VUE_APP_zichan+'/api/AssetsShop/distribute', params).then(res => {
					loading.close()
				console.log('res',res)
					if (res.code == 0) {
						this.$message({
							type: 'success',
							message: '分配成功!'
						});
						this.count='';
						this.userId='';
						this.getAssetInfo();
						this.dialogFormVisible=false;
					}
				})
			},
			// 查看员工资产
			listForStaff(row) {
				this.drawerSeeProduct_state = true;
				this.ForStaffInfo = row;
			},
			// 交接
			handoverT(row) {
				this.handoverShow = true;
				this.lockNumber = row.stockInfo.lock;
				
				// let loading = this.$loading();
				let params = {
					"receiveInfo": {
						"id": this.handoverId,
						"name": this.$public.getMatchingItem(this.StaffList, '_id', this.handoverId).basic_info.real_name,
					},
					"remark":'',
					"shopInfo": this.infoObj.shopInfo,
					  "assetsList": [
					      {
					        "assetsCode": row.assetsCode,
					        "assetsName": row.assetsName,
					        "skuName": row.skuName,
					        "count":this.countNumber*1,
					        "assetsType":  row.assetsType
					      }
					    ]
				}
				console.log('params',params)
				this.$http.post(process.env.VUE_APP_zichan+'/api/AssetsStaff/handover', params).then(res => {
					// loading.close()
				console.log('交接res',res)
					if (res.code == 0) {
						this.$message({
							type: 'success',
							message: '交接成功!'
						});
						this.countNumber='';
						this.handoverId='';
						this.getAssetInfo();
						this.handoverShow=false;
					}
				})
			},

			//获取员工列表
			getTableData() {
				let params = {
					'shopId': this.$store.state.shopId,
					'state': 1
				}
				this.$http.post(process.env.VUE_APP_Url2 + 'api/StaffInfo/list', params).then(res => {
					if (res.code == 0) {
						this.StaffList = res.data.data;
						console.log('获取员工列表',this.StaffList)
					}
				})
			},
			// 分配员工
			distribution() {
				this.dialogFormVisible = true;
			},
			// 全部解绑
			unbundlingAll() {
				this.$confirm('此操作将全部解绑, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let loading = this.$loading();
					let params = {
						"assetsCode": this.infoObj.assetsCode,
						"shopId": this.infoObj.shopInfo.id, 
					}
					console.log(params);
					this.$http.post(process.env.VUE_APP_zichan + '/api/AssetsStaff/unbind', params).then(res => {
						loading.close()
						// console.log('全部解绑', res)
						if (res.code == 0) {
							this.getAssetInfo()
							this.$message({
								type: 'success',
								message: '全部解绑成功!'
							});
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消全部解绑'
					});
				});
			},

			// 解绑
			unbundling(row) {
				console.log(row)
				this.$prompt('请输入要解绑的数量', `可解绑的数量${row.stockInfo.reality}`, {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputPattern: /^100$|^(\d|[1-9]\d)$/,
					inputErrorMessage: `解绑数量不能大于${row.stockInfo.reality}`
				}).then(({
					value
				}) => {
					let loading = this.$loading();
					let params = {
						"assetsCode": row.assetsCode,
						"shopId": row.shopInfo.id,
						"staffId": row.staffInfo.id,
						"count": value,
					}
					this.$http.post(process.env.VUE_APP_zichan + '/api/AssetsStaff/unbindForStaff', params).then(res => {
						loading.close()
						console.log('解绑', res)
						if (res.code == 0) {
							this.getAssetInfo()
							this.$message({
								type: 'success',
								message: '解绑成功'
							});
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '取消解绑'
					});
				});
			},


			//获取资产详情
			getAssetInfo() {
				let loading = this.$loading();
				let params = {
					"shopId": this.$route.query.info.shopInfo.id, //门店id
					"code": this.$route.query.info.assetsCode
				}
				this.$http.get(process.env.VUE_APP_zichan + '/api/AssetsStaff/listForCode', params).then(res => {
					loading.close()
					// console.log('资产详情', res)
					if (res.code == 0) {
						this.tableData = res.data;
					}
				})
			}
		}

	}
</script>

<style lang="scss" scoped>
	.page {
		height: 100%;

		// 重复头部
		.titleView {
			// width: 98%;
			padding: 20px 0;
			padding-left: 10px;
			margin: 0 auto;
			font-size: 14px;
			color: #2A2A2A;
			background: #fff;
			border-radius: 6px;
		}
	}

	::v-deep .el-input__inner {
		width: 200px;
	}
</style>
